/* Mom it Keto Go — Theme JS */
(function() {
  'use strict';

  // ─── HEADER SCROLL ───
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ─── SHOP DROPDOWN ───
  var shopDropdown = document.getElementById('shop-dropdown');
  var shopTrigger = shopDropdown && shopDropdown.querySelector('.nav-dropdown__trigger');
  var shopPanel   = shopDropdown && shopDropdown.querySelector('.nav-dropdown__panel');
  if (shopDropdown && shopTrigger && shopPanel) {
    function openDropdown() {
      shopDropdown.classList.add('is-open');
      shopTrigger.setAttribute('aria-expanded', 'true');
    }
    function closeDropdown() {
      shopDropdown.classList.remove('is-open');
      shopTrigger.setAttribute('aria-expanded', 'false');
    }
    shopTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      shopDropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });
    /* Close when clicking outside */
    document.addEventListener('click', function(e) {
      if (!shopDropdown.contains(e.target)) closeDropdown();
    });
    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeDropdown(); shopTrigger.focus(); }
    });
    /* Close when a panel link is clicked */
    shopPanel.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() { closeDropdown(); });
    });
    /* Optional: open on hover for desktop users */
    shopDropdown.addEventListener('mouseenter', function() { openDropdown(); });
    shopDropdown.addEventListener('mouseleave', function() { closeDropdown(); });
  }

  // ─── MEAL PLANS DROPDOWN ───
  var plansDropdown = document.getElementById('plans-dropdown');
  var plansTrigger  = plansDropdown && plansDropdown.querySelector('.nav-dropdown__trigger');
  var plansPanel    = plansDropdown && plansDropdown.querySelector('.nav-dropdown__panel');
  if (plansDropdown && plansTrigger && plansPanel) {
    function openPlans() {
      plansDropdown.classList.add('is-open');
      plansTrigger.setAttribute('aria-expanded', 'true');
    }
    function closePlans() {
      plansDropdown.classList.remove('is-open');
      plansTrigger.setAttribute('aria-expanded', 'false');
    }
    plansTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      plansDropdown.classList.contains('is-open') ? closePlans() : openPlans();
    });
    document.addEventListener('click', function(e) {
      if (!plansDropdown.contains(e.target)) closePlans();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closePlans(); plansTrigger.focus(); }
    });
    plansPanel.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() { closePlans(); });
    });
    plansDropdown.addEventListener('mouseenter', function() { openPlans(); });
    plansDropdown.addEventListener('mouseleave', function() { closePlans(); });
  }

  // ─── MOBILE NAV ───
  var toggle = document.querySelector('.mobile-nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen);
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileNav.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
      });
    });
    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
        toggle.focus();
      }
    });
  }

  // ─── PRODUCT IMAGE GALLERY ───
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var thumbs     = Array.from(gallery.querySelectorAll('.product-gallery__thumb'));
    var mainImg    = gallery.querySelector('.product-gallery__main img');
    var prevBtn    = gallery.querySelector('.gallery-arrow--prev');
    var nextBtn    = gallery.querySelector('.gallery-arrow--next');
    var currentIdx = 0;

    function goTo(idx) {
      if (!thumbs.length || !mainImg) return;
      idx = (idx + thumbs.length) % thumbs.length;
      currentIdx = idx;
      var url = thumbs[idx].getAttribute('data-full');
      if (url) {
        mainImg.src = url;
        mainImg.removeAttribute('srcset');
      }
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumbs[idx].classList.add('active');
      thumbs[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIdx + 1); });

    var touchStartX = 0;
    var mainWrap = gallery.querySelector('.product-gallery__main');
    if (mainWrap) {
      mainWrap.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? currentIdx + 1 : currentIdx - 1);
      }, { passive: true });
    }

    // Preload all full-size images in the background so switching is instant
    thumbs.forEach(function(thumb) {
      var url = thumb.getAttribute('data-full');
      if (url) { var img = new Image(); img.src = url; }
    });
  }


  // ─── QUANTITY CONTROLS ───
  function initQty(wrap) {
    var minusBtn = wrap.querySelector('.qty-minus');
    var plusBtn = wrap.querySelector('.qty-plus');
    var input = wrap.querySelector('.qty-input');
    if (!minusBtn || !plusBtn || !input) return;
    // product page: find the ATC button and hidden qty input in the sibling form
    var section = wrap.closest('.product-info__qty');
    var atcBtn = section ? section.parentElement.querySelector('.product-atc-btn') : null;
    var hiddenQty = section ? section.parentElement.querySelector('.product-qty-hidden') : null;
    var unitPrice = atcBtn ? parseInt(atcBtn.getAttribute('data-unit-price'), 10) : 0;
    function syncPrice(qty) {
      if (!atcBtn || !unitPrice) return;
      if (hiddenQty) hiddenQty.value = qty;
      var total = (unitPrice * qty / 100).toFixed(2);
      atcBtn.innerHTML = 'Add to Cart \u2014 AED ' + total;
    }
    minusBtn.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      if (v > 1) { input.value = v - 1; syncPrice(v - 1); }
    });
    plusBtn.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      input.value = v + 1; syncPrice(v + 1);
    });
  }
  document.querySelectorAll('.qty-control').forEach(initQty);

  // ─── CARD QUANTITY STEPPERS (updates ATC button price) ───
  function formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }
  function initCardQty(stepper) {
    var minus = stepper.querySelector('.qty-btn--minus');
    var plus  = stepper.querySelector('.qty-btn--plus');
    var input = stepper.querySelector('.qty-input');
    var form  = stepper.closest('.product-atc-form');
    var btn   = form ? form.querySelector('[data-unit-price]') : null;
    if (!minus || !plus || !input || !btn) return;
    var unitPrice = parseInt(btn.getAttribute('data-unit-price'), 10);
    function updateBtn() {
      var qty = parseInt(input.value, 10) || 1;
      var total = formatMoney(unitPrice * qty);
      btn.innerHTML = 'Add to Cart &mdash; AED ' + total;
    }
    minus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      if (v > 1) { input.value = v - 1; updateBtn(); }
    });
    plus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      input.value = v + 1; updateBtn();
    });
  }
  document.querySelectorAll('.qty-stepper').forEach(initCardQty);

  // ─── CARD QUANTITY PICKER (+ button → stepper popup) ───
  function initCardQtyPicker(form) {
    var openBtn  = form.querySelector('.pc-open-picker');
    var picker   = form.querySelector('.pc-qty-picker');
    var minusBtn = form.querySelector('.pc-qty-step--minus');
    var plusBtn  = form.querySelector('.pc-qty-step--plus');
    var numEl    = form.querySelector('.pc-qty-num');
    var hiddenQty = form.querySelector('.pc-qty-hidden');
    if (!openBtn || !picker) return;
    var count = 1;
    function showPicker() {
      count = 1; numEl.textContent = '1'; hiddenQty.value = '1';
      picker.classList.add('active');
      openBtn.style.opacity = '0'; openBtn.style.pointerEvents = 'none';
    }
    function hidePicker() {
      picker.classList.remove('active');
      openBtn.style.opacity = ''; openBtn.style.pointerEvents = '';
      count = 1;
    }
    openBtn.addEventListener('click', function(e) { e.stopPropagation(); showPicker(); });
    minusBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      if (count > 1) { count--; numEl.textContent = count; hiddenQty.value = count; }
    });
    plusBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var _pMax   = parseInt(plusBtn.dataset.max || '', 10);
      var _pVarId = parseInt(((form.querySelector('input[name="id"]') || {}).value) || '', 10);
      var _pCrtQ  = (!isNaN(_pVarId) && window._mkgoCartQty) ? (window._mkgoCartQty[_pVarId] || 0) : 0;
      if (!isNaN(_pMax) && _pMax > 0 && (_pCrtQ + count + 1) > _pMax) {
        showStockError(null, _pMax, Math.max(0, _pMax - _pCrtQ - count));
        return;
      }
      count++; numEl.textContent = count; hiddenQty.value = count;
    });
    picker.addEventListener('click', function(e) { e.stopPropagation(); });
    document.addEventListener('click', function() { hidePicker(); });
    form._hidePicker = hidePicker;
  }
  document.querySelectorAll('.product-card__plus-form').forEach(initCardQtyPicker);

  // ─── ADD TO CART (AJAX) ───
  /* ── Cart quantity state (prevents silent over-add) ── */
  window._mkgoCartQty = window._mkgoCartQty || {};
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    (cart.items||[]).forEach(function(it){ window._mkgoCartQty[it.variant_id] = (window._mkgoCartQty[it.variant_id]||0) + it.quantity; });
  }).catch(function(){});

  var atcForms = document.querySelectorAll('.product-atc-form');
  atcForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var isPickerConfirm = btn.classList.contains('pc-qty-confirm');
      var originalText = btn.textContent;
      if (isPickerConfirm) {
        btn.disabled = true;
        btn.style.opacity = '0.6';
      } else {
        btn.textContent = 'Adding…';
        btn.disabled = true;
      }

      var formData = new FormData(form);
      var data = {};
      formData.forEach(function(value, key) { data[key] = value; });

      /* Pre-submit inventory check (cart-state aware) */
      var _atcBtn     = form.querySelector('[type="submit"]');
      var _invQty     = parseInt((_atcBtn && _atcBtn.dataset.inventory) || '', 10);
      var _invPolicy  = (_atcBtn && _atcBtn.dataset.inventoryPolicy) || '';
      var _reqQty     = parseInt(data.quantity, 10) || 1;
      var _variantId  = parseInt(data.id, 10);
      var _cartQty    = (!isNaN(_variantId) && window._mkgoCartQty) ? (window._mkgoCartQty[_variantId] || 0) : 0;
      if (!isNaN(_invQty) && _invQty > 0 && (_cartQty + _reqQty) > _invQty) { /* blocks regardless of inventory_policy */
        btn.textContent = originalText;
        btn.disabled = false;
        var _remaining = Math.max(0, _invQty - _cartQty);
        showStockError(null, _invQty, _remaining);
        return;
      }

      var _prevCartQty = _cartQty; /* snapshot before add */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(data)
      })
      .then(function(res) {
        return res.json().then(function(body) {
          if (!res.ok) { var e = new Error('inv'); e.shopifyBody = body; e.status = res.status; throw e; }
          return body;
        });
      })
      .then(function(item) {
        /* Detect silent cap: Shopify accepted but added fewer items than requested */
        var _actuallyAdded = (!isNaN(_variantId) && item.quantity !== undefined)
          ? (item.quantity - _prevCartQty) : _reqQty;
        if (!isNaN(_invQty) && _invQty > 0 && _actuallyAdded < _reqQty) {
          /* Revert the silent partial add via /cart/change.js */
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: _variantId, quantity: _prevCartQty })
          }).catch(function(){});
          if (!isNaN(_variantId)) { window._mkgoCartQty[_variantId] = _prevCartQty; }
          if (!isPickerConfirm) { btn.textContent = originalText; btn.style.background = ''; }
          btn.disabled = false;
          showStockError(null, _invQty, Math.max(0, _invQty - _prevCartQty));
          return;
        }
        showCartNotification(item.title);
        /* Update cart-state map so next pre-submit check is accurate */
        if (!isNaN(_variantId)) { window._mkgoCartQty = window._mkgoCartQty || {}; window._mkgoCartQty[_variantId] = item.quantity; }
        // Increment badge by what was actually added
        document.querySelectorAll('.cart-count').forEach(function(el) {
          var cur = parseInt(el.textContent, 10) || 0;
          el.textContent = cur + _actuallyAdded;
          el.style.display = '';
        });
        if (isPickerConfirm) {
          btn.style.background = '#27ae60';
          btn.style.opacity = '1';
          setTimeout(function() {
            btn.style.background = '';
            btn.style.opacity = '';
            btn.disabled = false;
            if (form._hidePicker) form._hidePicker();
          }, 400);
        } else {
          btn.textContent = '✓ Added!';
          btn.style.background = '#27ae60';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 1000);
        }
      })
      .catch(function(err) {
        btn.style.opacity = '1';
        btn.disabled = false;
        if (err && err.shopifyBody && err.status === 422) {
          /* Use the button's data-inventory (set from Liquid) — always the real total stock */
          var _eb = form.querySelector('[type="submit"]');
          var avail = _eb ? parseInt(_eb.dataset.inventory || '', 10) : null;
          if (isNaN(avail)) { var d = err.shopifyBody.description || err.shopifyBody.message || ''; var m = d.match(/(\d+)/); avail = m ? parseInt(m[1], 10) : null; }
          if (!isPickerConfirm) { btn.textContent = originalText; btn.style.background = ''; }
          /* remaining = how many MORE can be added (total stock - what's already in cart) */
          var _r422 = (!isNaN(_variantId) && window._mkgoCartQty) ? Math.max(0, avail - (window._mkgoCartQty[_variantId] || 0)) : null;
          showStockError(null, avail, _r422);
        } else {
          if (!isPickerConfirm) {
            btn.textContent = 'Error – Try Again';
            setTimeout(function() { btn.textContent = originalText; }, 2000);
          }
        }
        if (form._hidePicker) form._hidePicker();
      });
    });
  });

  var cnTimer = null;
  function showCartNotification(title) {
    var notification = document.getElementById('cart-notification');
    var text  = document.getElementById('cart-notification-text');
    var label = notification ? notification.querySelector('.cart-notification__label') : null;
    var cta   = notification ? notification.querySelector('.cart-notification__cta') : null;
    if (!notification) return;
    if (cnTimer) clearTimeout(cnTimer);
    /* Snap to hidden start position without any transition playing */
    notification.style.transition = 'none';
    notification.classList.remove('cn-show', 'cn-hide', 'cn-stock-error');
    if (label) label.textContent = 'Added to your order';
    if (text)  text.textContent  = title;
    if (cta)   cta.style.display = '';
    void notification.offsetWidth; /* flush — element is now at hidden start */
    notification.style.transition = ''; /* restore CSS transitions */
    notification.classList.add('cn-show'); /* plays the drop-down animation */
    cnTimer = setTimeout(function() { dismissCartNotification(); }, 4000);
  }
  function dismissCartNotification() {
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    notification.classList.remove('cn-show');
    notification.classList.add('cn-hide');
    if (cnTimer) { clearTimeout(cnTimer); cnTimer = null; }
 }
  // Expose globally so any inline script can use the cart notification
  window.showCartNotification   = showCartNotification;

    function showStockError(title, available, remaining) {
      var notification = document.getElementById('cart-notification');
      if (!notification) return;
      clearTimeout(cnTimer);
      var label = notification.querySelector('.cart-notification__label');
      var text  = notification.querySelector('#cart-notification-text');
      var cta   = notification.querySelector('.cart-notification__cta');
      var hasRemaining = (remaining !== null && remaining !== undefined && !isNaN(remaining));
      var hasAvail     = (available  !== null && available  !== undefined && !isNaN(available));
      if (hasRemaining && remaining === 0) {
        if (label) label.textContent = 'Stock Limit';
        if (text)  text.textContent  = hasAvail ? 'Only ' + available + ' in stock' : 'Stock limit reached';
      } else if (hasRemaining && remaining > 0) {
        if (label) label.textContent = 'Only ' + remaining + ' more available';
        if (text)  text.textContent  = 'Stock limit: ' + (hasAvail ? available : remaining) + ' total';
      } else {
        if (label) label.textContent = hasAvail ? 'Only ' + available + ' left' : 'Out of stock';
        if (text)  text.textContent  = 'Reduce your quantity';
      }
      if (cta)   cta.style.display = 'none';
      notification.classList.add('cn-stock-error');
      notification.classList.remove('cn-hide', 'cn-show');
      void notification.offsetWidth;
      notification.classList.add('cn-show');
      cnTimer = setTimeout(function() {
        dismissCartNotification();
        notification.classList.remove('cn-stock-error');
        if (label) label.textContent = 'Added to your order';
        if (text)  text.textContent  = 'Item';
        if (cta)   cta.style.display = '';
      }, 4000);
    }
    window.showStockError = showStockError;
  window.dismissCartNotification = dismissCartNotification;  var closeBtn = document.getElementById('cart-notification-close');
  if (closeBtn) closeBtn.addEventListener('click', dismissCartNotification);

  function updateCartCount() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  }
  // Skip on cart page — main-cart.liquid owns the badge there (avoids race condition on remove)
  if (!document.querySelector('.cart-pg')) { updateCartCount(); }

  // ─── CART PAGE: handled by main-cart.liquid section script ───
  // ─── VARIANT SELECTION ───
  (function() {
    var variantBtns = document.querySelectorAll('.variant-btn');
    if (!variantBtns.length) return;
    var variantsEl = document.getElementById('product-variants-json');
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch(e) {}

    function getSelectedOptions() {
      var opts = {};
      document.querySelectorAll('.variant-group').forEach(function(g) {
        var active = g.querySelector('.variant-btn.active');
        if (active) opts[active.dataset.option] = active.dataset.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function(v) {
        return Object.keys(opts).every(function(pos) {
          return v['option' + pos] === opts[pos];
        });
      });
    }

    function fmtAed(cents) {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updatePriceDisplay(variant) {
      if (!variant) return;
      var priceAed = fmtAed(variant.price);
      var priceEl = document.querySelector('.product-info__price');
      if (priceEl) {
        var compare = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? ' <span class="compare">AED ' + fmtAed(variant.compare_at_price) + '</span>'
          : '';
        priceEl.innerHTML = 'AED ' + priceAed + compare;
      }
      var soldOut    = variant.inventory_policy === 'deny' && variant.inventory_quantity <= 0;
      var atStock    = variant.inventory_policy !== 'deny' || variant.inventory_quantity > 0;
      var atcBtn = document.querySelector('.product-atc-btn');
      if (atcBtn) {
        atcBtn.dataset.unitPrice = variant.price;
        atcBtn.dataset.inventory = variant.inventory_quantity || 0;
        atcBtn.dataset.inventoryPolicy = variant.inventory_policy || '';
        if (soldOut) {
          atcBtn.textContent = 'Sold Out';
          atcBtn.disabled = true;
          atcBtn.style.opacity = '0.5';
          atcBtn.style.cursor = 'not-allowed';
        } else {
          atcBtn.textContent = 'Add to Cart — AED ' + priceAed;
          atcBtn.disabled = false;
          atcBtn.style.opacity = '';
          atcBtn.style.cursor = '';
        }
      }
      /* Set max on qty input when policy is deny */
      var qtyInput = document.querySelector('.product-qty-input, [name="quantity"]');
      if (qtyInput && variant.inventory_policy === 'deny') {
        qtyInput.max = variant.inventory_quantity;
      } else if (qtyInput) {
        qtyInput.removeAttribute('max');
      }
      var idInput = document.querySelector('.product-atc-form [name="id"]');
      if (idInput) idInput.value = variant.id;
    }

    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.variant-group');
        if (group) group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updatePriceDisplay(findVariant(getSelectedOptions()));
      });
    });
  })();

  // ─── SMOOTH SCROLL FOR ANCHORS ───
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ─── ACTIVE NAV LINK ───
  var path = window.location.pathname;
  document.querySelectorAll('.site-nav a, .mobile-nav a').forEach(function(a) {
    if (a.getAttribute('href') === path || (path !== '/' && a.getAttribute('href') && path.startsWith(a.getAttribute('href')))) {
      a.classList.add('active');
    }
  });

  // ─── NEWSLETTER FORM ───
  var newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = newsletterForm.querySelector('input[type="email"]').value;
      var btn = newsletterForm.querySelector('button');
      btn.textContent = 'Subscribed! ✓';
      btn.disabled = true;
    });
  }

  // ─── PRODUCT CARD MINI MACRO CHIPS ───
  function pickMacro(patterns, src) {
    for (var i = 0; i < patterns.length; i++) {
      var m = src.match(patterns[i]);
      if (m) {
        var raw = m[1] !== undefined ? m[1] : (m[2] !== undefined ? m[2] : null);
        if (raw === null) continue;
        var n = parseInt(raw, 10);
        if (!isNaN(n) && n >= 0) return n;
      }
    }
    return null;
  }
  document.querySelectorAll('.pc-macros[data-desc]').forEach(function(el) {
    var t = (el.getAttribute('data-desc') || '').replace(/[\r\n\t]+/g,' ').replace(/\s{2,}/g,' ');
    if (!t) return;
    var cal = pickMacro([
      /net[\s\t]*kcal[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /net[\s\t]*cal(?:ories?|s)?[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /net[\s\t]*cal(?:ories?|s)?[\s\t]+(\d+)/i,
      /(\d+)[\s\t]*net[\s\t]*kcal/i,
      /(\d+)[\s\t]*net[\s\t]*cal(?:ories?|s)?/i,
      /cal(?:ories?|s)?[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /kcal[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /energy[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /(\d+)[\s\t]*kcal/i,
      /(\d+)[\s\t]*cal(?:ories?|s)?(?=[^a-z]|$)/i,
      /cal(?:ories?|s)?[\s\t]+(\d+)/i,
      /kcal[\s\t]+(\d+)/i
    ], t);
    var pro = pickMacro([
      /pro(?:teins?)?[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /(\d+)[\s\t]*g[\s\t]*pro(?:teins?)?(?=[^a-z]|$)/i,
      /(\d+)[\s\t]*pro(?:teins?)?(?=[^a-z]|$)/i,
      /pro(?:teins?)?[\s\t]+(\d+)/i
    ], t);
    var fat = pickMacro([
      /(?:total[\s\t]*)?fat[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /(\d+)[\s\t]*g[\s\t]*(?:total[\s\t]*)?fat(?=[^a-z]|$)/i,
      /(\d+)[\s\t]*(?:total[\s\t]*)?fat(?=[^a-z]|$)/i,
      /(?:total[\s\t]*)?fat[\s\t]+(\d+)/i
    ], t);
    var carb = pickMacro([
      /net[\s\t]*carb(?:ohydrate)?s?[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /(?:total[\s\t]*)?carb(?:ohydrate)?s?[\s\t]*[:\-\/][\s\t]*(\d+)/i,
      /(\d+)[\s\t]*g[\s\t]*net[\s\t]*carb(?:ohydrate)?s?(?=[^a-z]|$)/i,
      /(\d+)[\s\t]*g[\s\t]*carb(?:ohydrate)?s?(?=[^a-z]|$)/i,
      /(\d+)[\s\t]*net[\s\t]*carb(?:ohydrate)?s?(?=[^a-z]|$)/i,
      /(\d+)[\s\t]*carb(?:ohydrate)?s?(?=[^a-z]|$)/i,
      /net[\s\t]*carb(?:ohydrate)?s?[\s\t]+(\d+)/i,
      /(?:total[\s\t]*)?carb(?:ohydrate)?s?[\s\t]+(\d+)/i
    ], t);
    if (cal === null && pro === null && fat === null && carb === null) return;
    var html = '';
    if (cal  !== null) html += '<span class="pc-chip pc-chip--cal">'  + cal  + ' kcal</span>';
    if (pro  !== null) html += '<span class="pc-chip pc-chip--pro">P ' + pro  + 'g</span>';
    if (fat  !== null) html += '<span class="pc-chip pc-chip--fat">F ' + fat  + 'g</span>';
    if (carb !== null) html += '<span class="pc-chip pc-chip--carb">C '+ carb + 'g</span>';
    el.innerHTML = html;
  });

})();

// ─── PREDICTIVE SEARCH OVERLAY ───
(function() {
  'use strict';

  var overlay    = document.getElementById('search-overlay');
  var trigger    = document.getElementById('search-trigger');
  var input      = document.getElementById('search-overlay-input');
  var results    = document.getElementById('search-overlay-results');
  var closeBtn   = overlay ? overlay.querySelector('.search-overlay__close') : null;
  var backdrop   = overlay ? overlay.querySelector('.search-overlay__backdrop') : null;
  if (!overlay || !trigger || !input || !results) return;

  var currentQuery = '';
  var debounceTimer = null;
  var abortCtrl = null;

  // ── open / close ──────────────────────────────────────────────
  function openOverlay() {
    overlay.hidden = false;
    // rAF so display:block paints before the transition class is added
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.classList.add('is-open');
        input.focus();
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (!currentQuery) showPrompt();
      });
    });
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // hide after transition completes
    setTimeout(function() { overlay.hidden = true; }, 300);
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
  }

  trigger.addEventListener('click', openOverlay);
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (backdrop) backdrop.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !overlay.hidden) closeOverlay();
  });

  // ── prompt state (before typing) ─────────────────────────────
  var SUGGESTED = [
    { label: 'Meal Plans',    href: '/collections/meal-plan-packages#plan-packages' },
    { label: 'Bakery & Snacks',   href: '/collections/keto-snacks-and-breads' },
    { label: 'Desserts',      href: '/pages/desserts' },
    { label: 'Signature Dishes', href: '/collections/keto-signature-dishes' },
    { label: 'Best Sellers',  href: '/collections/best-selling' }
  ];

  function showPrompt() {
    var chips = SUGGESTED.map(function(s) {
      return '<a class="search-prompt__chip" href="' + s.href + '">' + s.label + '</a>';
    }).join('');
    results.innerHTML =
      '<div class="search-prompt">' +
        '<div class="search-prompt__chips">' + chips + '</div>' +
      '</div>';
  }

  // ── money formatting ──────────────────────────────────────────
  // /search/suggest.json returns prices as pre-formatted decimals (e.g. "45.00"), NOT cents
  function money(price) {
    if (price === null || price === undefined || price === '') return '';
    var n = typeof price === 'number' ? price : parseFloat(String(price).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return String(price);
    return 'AED\u00a0' + n.toFixed(2);
  }

  // Resolve image URL from any Shopify image shape (object or string)
  function imgUrl(image) {
    if (!image) return null;
    var src = typeof image === 'string' ? image : (image.src || image.url || image.original_src || null);
    if (!src || typeof src !== 'string') return null;
    // Insert Shopify CDN size modifier — handles URLs with and without query strings
    return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_400x400$1$2');
  }

  // ── render results ────────────────────────────────────────────
  function renderResults(products, query) {
    if (!products || !products.length) {
      results.innerHTML =
        '<div class="search-empty">' +
          '<div class="search-empty__icon">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>' +
          '</div>' +
          '<div class="search-empty__title">No results for &ldquo;' + escHtml(query) + '&rdquo;</div>' +
          '<div class="search-empty__sub">Try different keywords or browse a category above</div>' +
        '</div>';
      return;
    }

    var cards = products.map(function(p) {
      try {
        var src = imgUrl(p.image);
        var imgHtml = src
          ? '<img class="search-product-card__img" src="' + src + '" alt="' + escHtml(p.title) + '" loading="lazy" width="400" height="400">'
          : '<div class="search-product-card__img-wrap--placeholder" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>' +
            '</div>';

        var priceHtml;
        if (!p.available) {
          priceHtml = '<span class="search-product-card__unavailable">Out of stock</span>';
        } else {
          priceHtml = '<span class="search-product-card__price">' + money(p.price) + '</span>';
          if (p.compare_at_price && p.compare_at_price > p.price) {
            priceHtml +=
              '<span class="search-product-card__compare">' + money(p.compare_at_price) + '</span>' +
              '<span class="search-product-card__badge">Sale</span>';
          }
        }

        return '<a href="' + (p.url || '/products/' + p.handle) + '" class="search-product-card">' +
          '<div class="search-product-card__img-wrap">' + imgHtml + '</div>' +
          '<div class="search-product-card__body">' +
            '<div class="search-product-card__title">' + highlightTitle(p.title, query) + '</div>' +
            '<div class="search-product-card__price-row">' + priceHtml + '</div>' +
          '</div>' +
        '</a>';
      } catch(e) { return ''; }
    }).join('');

    var viewAllHref = '/search?q=' + encodeURIComponent(query) + '&type=product';

    results.innerHTML =
      '<div class="search-results__header">' +
        '<span class="search-results__label">Products</span>' +
        '<span class="search-results__count">' + products.length + ' result' + (products.length !== 1 ? 's' : '') + '</span>' +
      '</div>' +
      '<div class="search-results__grid">' + cards + '</div>' +
      '<div class="search-viewall">' +
        '<a href="' + viewAllHref + '" class="search-viewall__btn">' +
          'View all results' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</a>' +
      '</div>';
  }

  function showLoading() {
    results.innerHTML =
      '<div class="search-loader">' +
        '<div class="search-loader__dot"></div>' +
        '<div class="search-loader__dot"></div>' +
        '<div class="search-loader__dot"></div>' +
      '</div>';
  }

  // ── HTML escape ───────────────────────────────────────────────
  function escHtml(str) {
    return String(str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // Wraps every query word that appears in the title with a <mark> highlight tag
  function highlightTitle(title, query) {
    if (!query) return escHtml(title);
    var words = query.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return escHtml(title);
    var pattern = new RegExp(
      '(' + words.map(function(w) {
        return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('|') + ')',
      'gi'
    );
    var result = '', lastIndex = 0, match;
    while ((match = pattern.exec(title)) !== null) {
      result += escHtml(title.slice(lastIndex, match.index));
      result += '<mark class="search-highlight">' + escHtml(match[0]) + '</mark>';
      lastIndex = match.index + match[0].length;
    }
    result += escHtml(title.slice(lastIndex));
    return result;
  }

  // Handles to suppress everywhere on the storefront
  var HIDDEN_HANDLES = [
    'coming-soon-keto-kibbeh-bil-sanieh',
    'keto-lasagna-250g',
    'breakfast-lunch-snack',
    'breakfast-lunch-dinner-2-snacks',
    'breakfast-lunch-dinner-1-snack',
    'breakfast-dinner-snack',
    'breakfast-lunch-dinner',
    'one-meal-a-day',
    'lunch-dinner',
    'lunch-dinner-2-snacks',
    'lunch-dinner-1-snack',
    'breakfast-dinner',
    'breakfast-lunch',
    'bag-refundable-deposit'
  ];

  // ── fetch from Shopify predictive search API ──────────────────
  function fetchResults(query) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=8';
    return fetch(url, { signal: abortCtrl.signal })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        return products.filter(function(p) { return HIDDEN_HANDLES.indexOf(p.handle) === -1; });
      });
  }

  // ── input handler ─────────────────────────────────────────────
  input.addEventListener('input', function() {
    var q = input.value.trim();
    if (q === currentQuery) return;
    currentQuery = q;

    clearTimeout(debounceTimer);
    if (!q) {
      if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
      showPrompt();
      return;
    }

    showLoading();
    debounceTimer = setTimeout(function() {
      fetchResults(q)
        .then(function(products) { renderResults(products, q); })
        .catch(function(err) {
          if (err.name === 'AbortError') return;
          results.innerHTML = '<div class="search-empty"><div class="search-empty__title">Something went wrong</div><div class="search-empty__sub">Please try again</div></div>';
        });
    }, 280);
  });

  // Close overlay when clicking a result link
  results.addEventListener('click', function(e) {
    if (e.target.closest('a')) closeOverlay();
  });

})();
